import { mediaData } from '@/mocks/home';

const mediaImages = [
  'https://readdy.ai/api/search-image?query=Weekly%20entertainment%20roundup%20video%20thumbnail%20style%20abstract%20art%2C%20warm%20coral%20and%20golden%20modern%20design%2C%20clean%20editorial%20composition%20with%20ranking%20list%20visual%20elements%2C%20trendy%20youtube%20cover%20aesthetic&width=800&height=450&seq=media-1-51cg&orientation=landscape',
  'https://readdy.ai/api/search-image?query=Deep%20dive%20investigation%20style%20abstract%20editorial%20art%2C%20warm%20red%20and%20amber%20tones%2C%20evidence%20timeline%20visual%20motif%2C%20modern%20documentary%20cover%20style%2C%20clean%20composition&width=800&height=450&seq=media-2-51cg&orientation=landscape',
  'https://readdy.ai/api/search-image?query=Comedy%20talk%20show%20style%20abstract%20editorial%20art%2C%20warm%20golden%20and%20soft%20rose%20palette%2C%20entertaining%20fun%20vibrant%20mood%2C%20modern%20podcast%20cover%20aesthetic%2C%20clean%20minimal%20design&width=800&height=450&seq=media-3-51cg&orientation=landscape',
];

export default function Media() {
  return (
    <section id="media" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 text-center mb-3">
          吃瓜视频
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-10">热门吃瓜内容视频化呈现，随时随地观看</p>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {mediaData.map((item, i) => (
            <div
              key={i}
              className="group bg-background-50 rounded-xl overflow-hidden border border-background-200/70 hover:border-primary-200 transition-all duration-200 cursor-pointer"
            >
              {/* Thumbnail */}
              <div className="relative w-full aspect-video overflow-hidden bg-background-200">
                <img
                  src={mediaImages[i]}
                  alt={item.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 flex items-center justify-center">
                  <div className="w-12 h-12 flex items-center justify-center bg-primary-500/90 rounded-full group-hover:bg-primary-600 transition-colors">
                    <i className="ri-play-fill text-background-50 text-xl ml-0.5"></i>
                  </div>
                </div>
                <span className="absolute bottom-2 right-2 px-2 py-0.5 bg-foreground-950/70 text-background-50 text-[10px] rounded whitespace-nowrap">
                  {item.duration}
                </span>
              </div>

              {/* Info */}
              <div className="p-4">
                <h3 className="text-sm md:text-base font-bold text-foreground-950 leading-snug mb-2 line-clamp-2 group-hover:text-primary-600 transition-colors">
                  {item.title}
                </h3>
                <div className="flex items-center justify-between text-xs text-foreground-400">
                  <span className="bg-secondary-100 text-secondary-700 px-2 py-0.5 rounded whitespace-nowrap">
                    {item.category}
                  </span>
                  <span className="flex items-center gap-1">
                    <i className="ri-eye-line"></i>
                    {item.views}次观看
                  </span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}